import { render } from "./campanii-form.vue?vue&type=template&id=29a6d560&scoped=true&ts=true"
import script from "./campanii-form.vue?vue&type=script&lang=ts"
export * from "./campanii-form.vue?vue&type=script&lang=ts"

import "./campanii-form.vue?vue&type=style&index=0&id=29a6d560&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a6d560"]])

export default __exports__